import { Component } from '@angular/core';
import { FilterListComponent } from 'gung-list';

@Component({
    selector: 'sjoborg-filter-list',
    templateUrl: './sjoborg-filter-list.component.html',
    styleUrl: './sjoborg-filter-list.component.scss',
    standalone: false
})
export class SjoborgFilterListComponent<T> extends FilterListComponent<T> { }
